import { Connect } from '@resultadosdigitais/front-hub/react'

import App from './App'

window.recaptchaOptions = {
  useRecaptchaNet: true,
  enterprise: true,
}

export default Connect(App)
